export default {
  kaptchaUrl: "/pingansec/site/kaptcha/get",  //获取图片验证码地址
  PASITECLIENTUSERINFO: 'PASITECLIENTUSERINFO', //用户信息cookie的key
  ERRORMESSAGE: '网络请求异常',
  // orgPrefix: '/org',
  // sitePrefix: '/data',
  api: {
    // 用户注册
    register: '/auth/register',
    getClientTitle: '/auth/getClientTitle',
    // 检查是否登录
    checkUserLogin: '/auth/checkUserLogin',
    // 查看用户名是否存在
    checkExistUserName: '/auth/checkExistUserName',
    // 注销申请
    logoutApply: '/siteBaseOperate/client/logoutApply',
    // 亮照公示列表
    sitePublicityList: '/data/page/publicityList',
    // 所有亮照信息
    allSitePage: '/data/page/all',
    // 查询我的亮照分页列表
    queryMyList: '/data/queryMyList',
    // 查询最近一个月亮照数据
    selectNearMonth: '/data/selectNearMonth',
    // 变更申请
    changeApply: '/data/changeApply',
    // 管辖单位列表
    selectOrgTree: '/org/persistent/queryTree',
    // 发送邮件
    sendEmailCode: '/auth/sendEmailCode',
    // 带参
    sendEmailCodeByEmail: '/auth/sendEmailCodeByEmail',
    sendPhoneCode: '/auth/sendPhoneCode',
    // 检查验证码是否正确
    checkEmailCode: '/auth/checkEmailCode',
    // 忘记密码,重新设置
    forgetResetPassword: '/auth/forgetResetPassword',
    // 重置密码
    resetPassword: '/auth/resetPassword',
    // 修改用户信息
    updateInfo: '/auth/updateInfo',
    // 获取用户信息
    getUserInfo: '/auth/getUserInfo',

    applySiteBaseInfoUrl: 'data/persistent/addSiteBase',
    // 插叙企业分类列表
    companyTypeList: '/companyType/list',
    // 用户登录
    login: '/auth/login',
    // aes key
    aesKey: 'mgJ4fKZRkeq0G9HB',
    // 退出登录
    logout: '/auth/logout',
    orgQuery: '/org/query',
    // 添加异议
    addSiteComplain: '/data/addSiteComplain',
    // 获取亮照详情
    getSiteBaseInfoById: '/data/getSiteBaseInfoById/',
    // 修改亮照信息重新提交申请
    updateSiteBaseInfo: '/data/update/siteBaseInfo/'
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/config.js